'use client'

import dynamic from 'next/dynamic'

export const YandexBadgesClient = dynamic(() => import(`./YandexBadges`).then(({ YandexBadges }) => YandexBadges), {
	ssr: false
})
